
import { Button } from "@/components/ui/button";
import { useSession } from "@supabase/auth-helpers-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const AuthButtons = () => {
  const session = useSession();
  const { t } = useTranslation("nav");
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-2">
      {!session ? (
        <Button 
          variant="ghost" 
          onClick={() => navigate("/login")}
        >
          {t("login")}
        </Button>
      ) : (
        <Button 
          variant="ghost" 
          onClick={() => supabase.auth.signOut()}
        >
          {t("logout")}
        </Button>
      )}
    </div>
  );
};
